import styled from '@emotion/styled';
import { motion } from 'framer-motion';

import { colors } from 'src/styles';

export const ImageViewerContainer = styled(motion.div)`
  top: 0;
  left: 0;
  position: fixed;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.4rem;
`;

export const ImageViewDummyContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

export const Image = styled.img`
  width: auto;
  max-width: 60%;
  max-height: 80%;
  user-select: none;
  border-radius: 1rem;
`;

export const IconButton = styled.button`
  border: none;
  outline: none;
  background: ${colors.white};
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 2rem;
  cursor: pointer;
  transition: opacity 0.2s;
`;

export const CloseButton = styled(IconButton)`
  top: 2rem;
  right: 2rem;
  position: absolute;
  background: none;
`;
